import { addAction, INIT, $ } from '@situation/setdesign.util';

addAction(INIT, () => {
    $('.row-slider .container')
        .addClass('owl-carousel')
        .owlCarousel({
            items: 1,
            dots: false,
            nav: true,
            navText: [
                '<span class="icon"><svg><use xlink:href="#icon-long-arrow"></use></svg></span>',
                '<span class="icon"><svg><use xlink:href="#icon-long-arrow"></use></svg></span>',
            ],
        })
        .on('changed.owl.carousel', (event) => {
            if (event.property.name === 'position') {
                SetDesign.updateLayout();
            }
        });
});
